import _objectSpread from "/usr/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import React from "react";
var __jsx = React.createElement;
import { useState } from "react";
import { useTranslation } from "@i18n";
import { CDN_LINK } from "@globalConfig";
import BottomSheetPopup from "@componentsShared/BottomSheetPopup__OLD/BottomSheetPopup";
import stl from "./DmanProgram.module.css";
import SingleDmanBox from "./SingleDmanBox";
import { useLang } from "@/common/Contexts/LanguageContext";
import { trackEvents } from "@/common/events/events";
import useHelpers from "@hooks/useHelpers";
import { usePostDetails } from "@/common/Contexts/PostDetailsContext";
import { twMerge } from "tailwind-merge";
var DmanProgram = function DmanProgram(_ref) {
  var _postDetails$details, _postDetails$details$, _postDetails$details2, _postDetails$details3, _qualitySection$popup;
  var qualitySection = _ref.qualitySection;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useHelpers = useHelpers(),
    createUrl = _useHelpers.createUrl;
  var _usePostDetails = usePostDetails(),
    helpers = _usePostDetails.helpers,
    postDetails = _usePostDetails.postDetails;
  var _useState = useState(false),
    ShowPopUp = _useState[0],
    setShowPopUp = _useState[1];
  var lang = useLang();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: [stl.container, (postDetails === null || postDetails === void 0 ? void 0 : (_postDetails$details = postDetails.details) === null || _postDetails$details === void 0 ? void 0 : (_postDetails$details$ = _postDetails$details.bnpl_options) === null || _postDetails$details$ === void 0 ? void 0 : _postDetails$details$.length) > 0 && "!pt-0"].join(" "),
    id: "daman-program-container"
  }, lang === "ar" ? /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/uspMainDT.svg",
    id: "uspMainDT",
    alt: "title",
    loading: "eager",
    width: 227,
    height: 80,
    className: twMerge((postDetails === null || postDetails === void 0 ? void 0 : (_postDetails$details2 = postDetails.details) === null || _postDetails$details2 === void 0 ? void 0 : (_postDetails$details3 = _postDetails$details2.bnpl_options) === null || _postDetails$details3 === void 0 ? void 0 : _postDetails$details3.length) > 0 && "!mt-0")
  }) : /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/GuaranteedENNew.svg",
    id: "GuaranteedENNew",
    alt: "title",
    width: 227,
    height: 80
  }), /*#__PURE__*/React.createElement("div", {
    className: stl.dmanOptions,
    id: "daman-options",
    "data-compare-id": "compare-daman-options"
  }, qualitySection === null || qualitySection === void 0 ? void 0 : qualitySection.usps.map(function (item, idx) {
    return /*#__PURE__*/React.createElement(SingleDmanBox, {
      key: "myDman" + idx,
      index: idx,
      icn: item.icon,
      text: item.title,
      content: item.contant
    });
  })), /*#__PURE__*/React.createElement("button", {
    className: stl.infoDman,
    id: "daman-learn-more-button",
    onClick: function onClick() {
      setShowPopUp(true);
      trackEvents("usp_view", _objectSpread(_objectSpread({}, helpers.getG4_data()), {}, {
        usp_type: t("اعرف المزيد عن برنامج ضمان السيارات من سيارة", {
          ns: "web_post_view"
        })
      }));
    }
  }, t("اعرف المزيد عن برنامج ضمان السيارات من سيارة", {
    ns: "web_post_view"
  }))), /*#__PURE__*/React.createElement(BottomSheetPopup, {
    show: ShowPopUp,
    onClose: function onClose() {
      setShowPopUp(false);
    },
    className: stl.customPostViewPopup
  }, /*#__PURE__*/React.createElement("div", {
    className: stl.mainDmanPopUpDP
  }, /*#__PURE__*/React.createElement("img", {
    src: qualitySection && qualitySection.popup && qualitySection.popup.main_img,
    alt: "image"
  }), /*#__PURE__*/React.createElement("div", {
    className: stl.mainPopupInfpDP
  }, qualitySection && qualitySection.popup && qualitySection.popup.items && Object.entries(qualitySection === null || qualitySection === void 0 ? void 0 : (_qualitySection$popup = qualitySection.popup) === null || _qualitySection$popup === void 0 ? void 0 : _qualitySection$popup.items).map(function (item, idx) {
    return /*#__PURE__*/React.createElement("div", {
      key: "myDmanDiv" + idx
    }, /*#__PURE__*/React.createElement("img", {
      src: item[1].icon,
      alt: "icon"
    }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("strong", null, item[1].title.replace(/100/g, "200")), /*#__PURE__*/React.createElement("p", null, item[1].contant.replace(/100/g, "200"))));
  }))), /*#__PURE__*/React.createElement("div", {
    className: stl.termsAndConditions
  }, /*#__PURE__*/React.createElement("a", {
    href: createUrl("/car-purchase-terms-conditions")
  }, t("تطبق الشروط والأحكام", {
    ns: "web_post_view"
  })))));
};
export default DmanProgram;